export default function InputRadio({
  id,
  label,
  answerOption,
  handleChange,
  errorMessage,
  register,
  disabled,
  isVerticalAlign,
  value,
  required,
  testId,
  standardQuestionName,
}) {
  return (
    <div className="inline-flex space-x-4">
      {label != undefined ? (
        <div
          className="questionnaire font-semibold max-w-[538px]"
          id={"question" + id}
        >
          {label}
        </div>
      ) : (
        ""
      )}

      <div
        id={id}
        className={
          isVerticalAlign ? "flex flex-col" : "flex flex-row items-center"
        }
        aria-labelledby={"question" + id}
      >
        {answerOption.map((option, i) => (
          <span
            key={i}
            className={isVerticalAlign ? "custom__radio-wrapper column" : ""}
          >
            {value ? (
              <input
                {...register}
                id={option.id}
                onChange={handleChange}
                value={option.value}
                className={
                  required ? "custom__radio Mandatory" : "custom__radio"
                }
                type="radio"
                // name={option.name}
                data-cy={testId + "_" + option.value}
                disabled={disabled}
                checked={value === option.value}
                standardquestionname={standardQuestionName}
              />
            ) : (
              <input
                {...register}
                id={option.id}
                onChange={handleChange}
                value={option.value}
                className={
                  required ? "custom__radio Mandatory" : "custom__radio"
                }
                type="radio"
                // name={option.name}
                data-cy={testId + "_" + option.value}
                disabled={disabled}
                standardquestionname={standardQuestionName}
              />
            )}
            <label htmlFor={option.id} className="inline-size">
              <span dangerouslySetInnerHTML={{ __html: option.label }} />
            </label>
          </span>
        ))}
        <span
          className="font-semibold text-secondary-red"
          data-cy="errorMessageRadio"
        >
          {errorMessage}
        </span>
      </div>
    </div>
  );
}
